'use client';

import classnames from 'classnames';

import type { ListProps } from './List.types';
import { ListItem } from './layout/ListItem';

import styles from './List.module.scss';

function List({ style, className, items, testId = 'ui-list' }: ListProps) {
  return (
    <div
      style={style}
      className={classnames(styles['list'], className)}
      data-testid={testId}
    >
      {items.map((item, index) => (
        <ListItem
          key={index}
          item={item}
          data-testid={`${testId}_item-${index}`}
        />
      ))}
    </div>
  );
}

export { List };
